import { isIE } from './browser';

/**
 * Проверка на выход содержимого узла
 * за его границы
 * @param {Node} node
 * @return {Boolean}
 */
export default (function (node) {
    if (!node) {
        return false;
    }

    if (isIE()) {
        return node.scrollWidth > Math.ceil(node.getBoundingClientRect().width);
    } else {
        return node.scrollWidth > node.clientWidth;
    }
});